import styled from "styled-components";

export const Style = styled.div`
  .footerWrap {
    position: relative;
    display: flex;
    width: 100%;
    background: linear-gradient(
      180deg,
      #8a8a8a 2.48%,
      #666666 11.89%,
      #303030 84.91%,
      #000000 94.32%
    );
  }

  .divider {
    width: 6px;
    background: linear-gradient(90deg, #1a1a1a 0%, #aeaeae 100%);
  }

  .request {
    position: relative;
    flex: 1;
    padding: 10px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .cntButton {
    position: absolute;
    top: -30px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 20px;
    font-weight: 600;
    color: #fff;
    padding: 12px 20px;
    background: #ff3030;
    border-radius: 50px;
  }

  .missedCallWrap {
    min-width: 300px;
    position: absolute;
    top: -20px;
    left: 50%;
    transform: translateX(-50%) translateY(-100%);
    padding: 20px 20px 10px 20px;
    background: #fff;
    border-radius: 20px;
    .listWrap {
      max-height: 300px;
      overflow-y: auto;
      overflow-x: hidden;
      border: none;
      padding: 0 10px;
    }

    .callItemWrap {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 12px 0;
      border-top: 1px solid #f1f1f1;

      h3 {
        font-size: 20px;
        color: #ff4a4a;
        font-weight: 600;
      }
      button {
        padding: 0;
      }
      img {
        width: 50px;
        height: 50px;
        padding: 10px;
        background: #009712;
        rotate: -135deg;
        border-radius: 50%;
      }
    }
    .callItemWrap:nth-child(0) {
      border-top: none;
    }
    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 20px;
      h2 {
        font-size: 22px;
        color: #555;
        font-weight: 600;
      }
      button.delete {
        padding: 10px 14px;
        border-radius: 10px;
        border: 1px solid #a7a7a7;
        font-size: 18px;
        font-weight: 500;
        color: #555;
      }
    }
  }

  .buttonWrap {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 14px;
    padding: 16px 0;
    font-size: 28px;
    color: #fff;
    font-weight: 600;
  }
`;
